module.exports = __webpack_public_path__ + "img/mobile-engagement-popup.21ad7b4e.png";